// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.5 9.5H9.5V14.5H14.5V9.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 0.5V3H15V0.5H17V3H21V7H23.5V9H21V15H23.5V17H21V21H17V23.5H15V21H9V23.5H7V21H3V17H0.5V15H3V9H0.5V7H3V3H7V0.5H9ZM7.5 7.5V16.5H16.5V7.5H7.5Z"}}]};

const CpuFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cpu-filled',
    ref,
    icon: element,
  },
));

CpuFilledIcon.displayName = 'CpuFilledIcon';

export default CpuFilledIcon;
